module.exports = __webpack_public_path__ + "img/tuto_img_internet_03.9cccb442.png";